import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TicketManager } from '@routes/ticket-manager';
import { PageEvent } from '@shared/models/page-event';
import Utils from '@shared/utils/utils';
import { ApiService } from '@shared/apis';
import { SpinnerService } from '@shared/services/spinner.service';
import { finalize } from 'rxjs/operators';
import { PagedResponse } from '@shared/models/paged-response';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TicketInfo } from '@shared/models/ticket-info';
import { AuthService } from '@core/auth/auth.service';
import Roles from '@shared/constants/roles';
import { Constants } from '@shared/constants/constants';
import { SearchFilterComponent } from '@routes/dialogs/search-filter/search-filter.component';
import { Subject } from 'rxjs';
import { EventService } from '@shared/services/event.service';
import SharedStorage from '@shared/services/shared-storage';
import { Options } from '@shared/models/options';
import Configs from '@shared/constants/configs';
import * as _ from 'lodash-es';
import Swal from 'sweetalert2';
import { ParamsBuilder } from '@shared/models/params-builder';
import DateUtils from '@shared/utils/date-utils';
import { environment } from '@env/environment';
import { FileService } from '@shared/services/file.service';
import { Company } from '@shared/enums/company';
import { Router } from '@angular/router';
import { MenuService } from '@layouts/menu/menu.service';
import { DpListComponent } from '@components/dp-list/dp-list.component';

const DACOR_MODELS = ['D3', 'D4', 'D5', 'D7', 'D8', 'DA', 'DB', 'DC', 'DD', 'DE', 'DF', 'DG', 'DH', 'DJ', 'DL', 'DM'];

@Component({
  selector: 'app-ticket-views',
  templateUrl: './ticket-views.component.html',
  styleUrls: ['./ticket-views.component.scss']
})
export class TicketViewsComponent implements OnInit, OnDestroy {
  readonly configs = Configs;
  readonly backend = environment.api.backend;
  readonly constants = Constants;
  readonly color = Configs.badgeColor;
  readonly filterKey = 'filter';
  realPage: number;

  isSwitchUser = false;
  isAdmin = false;
  showTat = false;

  pagedResponse: PagedResponse;

  q: any;
  query: any;
  subQuery: any;
  filter: any;
  showFilter: boolean;
  disableFilter: any = {};

  dateData = {
    startDate: null,
    endDate: null,
  };
  startDate: Date;
  endDate: Date;
  today: any;
  openCalender: boolean = false;

  ticketFilters: any[] = [];
  myFilters: any[] = [];
  filterList: any[] = [];
  selectedTicketFilter: any;

  tickets: TicketInfo[] = [];
  selectedTicket: any;
  hqStores: any;
  dealerStoreBpNo: any = [];

  bsModalRef: BsModalRef;

  destroy: Subject<any> = new Subject<any>();

  companies = Company;
  company;

  isPayment = false;
  @ViewChild(DpListComponent) dpListComponent: DpListComponent;
  private alive = true;

  constructor(private ticketManager: TicketManager,
              private modalService: BsModalService,
              private spinnerService: SpinnerService,
              private authService: AuthService,
              private cdRef: ChangeDetectorRef,
              public eventService: EventService,
              private apiService: ApiService,
              private fileService: FileService,
              private menuService: MenuService,
              private router: Router,) {
    this.isAdmin = this.authService.hasType(Roles.admin);
    this.isSwitchUser = this.authService.hasType(Roles.switchView);
    this.showTat = this.authService.hasType(Roles.admin) || this.authService.hasType(Roles.sysAdmin);
    this.company = this.authService.getCurrentCompany();
  }

  ngOnInit(): void {
    this.filter = {};
    this.showFilter = [this.companies.Sea, this.companies.Seca].includes(this.company) ||
      ([this.companies.SeaIm].includes(this.company) && this.isAdmin);
    if (this.isAdmin) {
      this.getDealers();
    }
    this.getTicketDealerSummary();
  }

  getDealers(pageEvent?: PageEvent) {
    return new Promise<void>((resolve, reject) => {
      this.apiService.dealer.getDealers(pageEvent, this.q, this.subQuery)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          this.dealerStoreBpNo = res.docs.map(item => item.bpNo)
          resolve();
        }, err => Utils.showError(err));
    })
  }

  ngOnDestroy() {
    this.alive = false;
  }

  toggle(index: number) {
    // 멀티 오픈을 허용하지 않으면 타깃 이외의 모든 submenu를 클로즈한다.
    /*if (true) {
      this.dealerSummary
        .filter((menu, i) => i !== index && menu.active)
        .forEach(menu => (menu.active = !menu.active));
    }*/

    // Menu의 active를 반전
    this.ticketFilters[index].active = !this.ticketFilters[index].active;
  }

  getTicketDealerSummary() {
    const pageEvent = new PageEvent();

    this.myFilters = [];
    this.ticketFilters = [];

    const opt: Options = {
      filter: this.filter,
    }

    this.spinnerService.start();
    this.apiService.ticket.getTicketFilter(pageEvent)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe((res: PagedResponse) => {
        this.filterList = res.docs || [];
        res.docs.forEach(item => {
          if (item.systemCode) {
            this.ticketFilters.push(item);
            return;
          }

          this.myFilters.push(item);
        });
        this.ticketFilters = this.ticketFilters.sort((a, b) => a.displayOrder > b.displayOrder ? 1 : -1);
        const item = JSON.parse(SharedStorage.getItem(this.filterKey));
        if (item) {
          this.selectTicketFilterRow(item);
        } else {
          const [first] = this.ticketFilters;
          this.selectTicketFilterRow(first);
        }
      }, err => Utils.showError(err));
  }

  selectTicketFilterRow(data) {
    this.selectedTicketFilter = data;
    this.isPayment = 'Draft Tickets' === data?.name && [this.companies.SeaIm].includes(this.company);

    SharedStorage.setItem(this.filterKey, JSON.stringify(data));
    this.filter = null;

    if (data.filter) {
      this.filter = data.filter;
    }

    this.dateData = {
      startDate: null,
      endDate: null,
    }
    const systemCodeList = ['CREATED_TODAY', 'CREATED_YESTERDAY', 'COMPLETED_TODAY', 'LTP']
    this.openCalender = !systemCodeList.includes(data.systemCode);

    this.showList();
  }

  onPageEvent(pageEvent: PageEvent) {
    this.showList(pageEvent);
  }

  showList(pageEvent?: PageEvent) {
    this.spinnerService.start('table');
    this.apiService.ticket.getTickets(pageEvent, this.options())
      .pipe(finalize(() => this.spinnerService.stop('table')))
      .subscribe(res => {
        this.pagedResponse = res;
        this.tickets = res.docs.map(m => {
          m.isDacorModel = DACOR_MODELS.includes(m.categoryIdNum);
          m.serviceTypeName = Constants.serviceTypeWithName
            .find(serviceType => serviceType.company === this.company && serviceType.code === m.serviceType)?.name || m.serviceType;
          return m;
        });
      }, err => Utils.showError(err));
  }

  options() {
    const opt: Options = {
      q: this.q,
      query: this.query,
      filter: this.filter,
      startDate: this.dateData.startDate,
      endDate: this.dateData.endDate,
    };
    return opt;
  }

  selectDetailRow(ticketInfo) {
    // ticketInfo.entryPath = 'detail';
    this.ticketManager.addTicket(ticketInfo);
  }

  showFilterOpen(e, isMyList = false) {
    if (e) {
      const filter = _.cloneDeep(this.filter);
      const [defaultFilter] = this.filterList.filter(f => f._id === this.selectedTicketFilter._id).map(m => m.filter);

      const initialState = {
        isMyList,
        filter: filter,
        defaultFilter,
        disableFilter: this.disableFilter,
        isSystemFilter: !!this.selectedTicketFilter.systemCode
      };

      this.bsModalRef = this.modalService.show(SearchFilterComponent, {
        class: 'modal-xxl',
        initialState,
      });

      this.bsModalRef.content.onClose.subscribe(filter => {

        if (filter) {
          this.filter = filter;
          const item = JSON.parse(SharedStorage.getItem(this.filterKey));
          item.filter = filter;
          SharedStorage.setItem(this.filterKey, JSON.stringify(item));
        } else {
          SharedStorage.removeItem(this.filterKey);
        }
        this.getTicketDealerSummary();
        // this.showList();
      });
    }
  }

  search(e) {
    this.q = e.target.value.trim();
    this.showList();
  }

  startDateChange(dateData) {
    this.dateData = dateData;
    if (dateData.startDate || dateData.endDate) {
      this.showList();
    }
  }

  // exportResultOld(e) {
  //   this.spinnerService.start('table');
  //   this.apiService.ticket.exportTickets(null, e)
  //     .pipe(finalize(() => this.spinnerService.stop('table')))
  //     .subscribe(res => {
  //       Swal.fire({
  //         title: 'Ticket List was exported',
  //         text: 'Ticket list would be sent to your email address.',
  //         icon: 'success',
  //         allowOutsideClick: false,
  //       }).then((result) => {
  //       });
  //
  //     }, err => Utils.showError(err));
  // }

  exportResult(pageEvent?: PageEvent) {
    const opt: Options = this.options();

    if (!pageEvent) {
      pageEvent = new PageEvent();
      pageEvent.limit = this.configs.pagination.sizeOptions[0];
      this.realPage = pageEvent.page;
    }

    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (opt?.q) {
      builder.q = opt.q;
    }
    if (opt?.query) {
      builder.query = opt.query;
    }
    if (opt?.filter) {
      builder.filter = opt.filter;
    }
    if (opt?.startDate) {
      builder.startDate = opt.startDate;
    }
    if (opt?.endDate) {
      builder.endDate = opt.endDate;
    }

    if (this.pagedResponse.totalDocs >= 1000) {
      builder.export = 'email';
      this.spinnerService.start('table');
      this.apiService.ticket.exportTickets(builder.build())
        .pipe(finalize(() => this.spinnerService.stop('table')))
        .subscribe(res => {
          Swal.fire({
            title: 'Ticket List was exported',
            text: 'Ticket list would be sent to your email address.',
            icon: 'success',
            allowOutsideClick: false,
          }).then((result) => {
          });
        }, err => Utils.showError(err));
    } else {
      builder.export = 'download';
      const isPost = true;
      const fileName = `TICKET-${ DateUtils.toHqMomentFormat(new Date(), 'YYYYMMDDHHmmssSSS') }`;
      this.fileService.downloadFile(this.backend.concat('/ticket/export'), fileName, builder.build(), isPost);
    }
  }

  goToPayment(event) {
    const menu = this.menuService.getMenu();
    const payments = menu.find(f => f.componentId === 'payments');
    this.menuService.selectedMenu$.next(payments);
    return this.router.navigate(['/payments']);
  }

  calculateTat(ticket: TicketInfo): string {
    if (!ticket.postingDate) {
      return '';
    }

    const completedStatuses = ['ST035', 'ST040'];
    const canceledStatuses = ['ST050', 'ST051', 'ST052'];

    let endDate: string;

    if (completedStatuses.includes(ticket.status)) {
      // For completed tickets: completeDate - postingDate
      endDate = ticket.completeDate;
    } else if (canceledStatuses.includes(ticket.status)) {
      // For canceled tickets: find the status change date in changeLogs
      const cancelLog = ticket.changeLogs?.find(log => canceledStatuses.includes(log.status));
      endDate = cancelLog?.changeDate || ticket.lastUpdateDate;
    } else {
      // For other statuses (LTP - Long Time Pending): currentDate - postingDate
      endDate = new Date().toISOString();
    }

    if (!endDate) {
      return '';
    }

    const startMoment = DateUtils.getHqMoment(ticket.postingDate);
    const endMoment = DateUtils.getHqMoment(endDate);
    const days = endMoment.diff(startMoment, 'days');

    return `${days}`;
  }

  getTatClass(ticket: TicketInfo): string {
    const completedStatuses = ['ST035', 'ST040'];
    const canceledStatuses = ['ST050', 'ST051', 'ST052'];

    const baseClass = 'tat-cell';

    if (completedStatuses.includes(ticket.status)) {
      return `${baseClass} tat-completed`;
    } else if (canceledStatuses.includes(ticket.status)) {
      return `${baseClass} tat-canceled`;
    } else {
      // LTP status - check days
      if (!ticket.postingDate) {
        return baseClass;
      }

      const startMoment = DateUtils.getHqMoment(ticket.postingDate);
      const endMoment = DateUtils.getHqMoment(new Date());
      const days = endMoment.diff(startMoment, 'days');

      if (days <= 14) {
        return `${baseClass} tat-ltp-green`;
      } else {
        return `${baseClass} tat-ltp-red`;
      }
    }
  }

  cancelTicket($event, ticket) {
    $event.stopPropagation();
    $event.preventDefault();
    Swal.fire({
      title: 'Are you sure to cancel the ticket?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        const body = {
          ascNo: ticket.ascNo,
          serviceType: ticket.serviceType,
        }
        this.spinnerService.start();
        this.apiService.ticket.cancelTicket(ticket.ticketNo, body)
          .pipe(finalize(() => this.spinnerService.stop()))
          .subscribe(res => {
            Swal.fire('Ticket was canceled successfully', '', 'success')
              .then(r => this.showList());
          }, err => Utils.showError(err));
      } else if (result.isDenied) {
        Swal.fire('Canceled!', '', 'info');
      }
    });
  }
}
